<template>
  <div>
    <div v-show="false"> {{getTasksListCounter}} </div>
    <v-container :class="ui.bkgdColor">
      <v-layout row class="mb-1 mt-2 ml-2 mr-1">
        <v-chip :color="ui.chipColor" :class="ui.textSubheading">
          Procedure Resources
        </v-chip>
        <v-spacer/>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> list </v-icon>
          </v-avatar>
          Tasks
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{getTasksList.length}} steps
        </v-chip>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> schedule </v-icon>
          </v-avatar>
          Time
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{this.calcTaskListHours(this.getTasksList)}} hrs
        </v-chip>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> person </v-icon>
          </v-avatar>
          Roles
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{this.calcTaskListPersonRoles(this.getTasksList)}}
        </v-chip>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> pending_actions </v-icon>
          </v-avatar>
          Person Hours
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{this.calcTaskListPersonHours(this.getTasksList)}} ph
        </v-chip>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> category </v-icon>
          </v-avatar>
          Resources
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{this.calcTaskListParts(this.getTasksList)}}
        </v-chip>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import tasksFunctions from "@/data/functions/mixins/tasksFunctions.js";
export default {
  mixins: [apptheme, dateFunctions, revFunctions, tasksFunctions],
  computed: {
    ...mapGetters(["getTasksList", "getTasksListCounter"])
  },
  data() {
    return {
      valid: false
    };
  }
};
</script>
